import * as auth from './auth';
import * as fire from './fire';
import * as db from './db';

export {
  auth,
  fire,
  db,
};


// WEBPACK FOOTER //
// ./src/firebase/index.js